import { Component, ReactNode, ErrorInfo } from 'react';
import { handleError } from '@/utils/error';

type ErrorBoundaryProps = {
  children: ReactNode;
};

type ErrorBoundaryState = {
  hasError: boolean;
  error?: Error | null;
};

export class ErrorBoundary extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { error, hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    handleError(error, errorInfo, 'error', 'ErrorBoundary caught an error');
  }

  render(): ReactNode {
    if (this.state.hasError) {
      // Render nothing if there's an error
      return null;
    }

    return this.props.children;
  }
}
